import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../../components/button'
import { Input } from '../../../../../components/input'
import { Loader } from '../../../../../components/loader'
import { PageContainer } from '../../../../../components/page-container/page-container'
import { showToast } from '../../../../../components/sonner'
import { useMask } from '../../../../../hooks/useMask'
import type { RootState } from '../../../../../redux/global-store'
import { paths } from '../../../../../router/paths'
import { formatDPI } from '../../../../../utils/masks/formatDPI'
import { generateTokenRequest, resetPasswordUpdateState, resetPasswordResetState } from '../../../presentation/redux/actions/reset-password-actions'

export const InformTaxId = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [taxId, setTaxId] = useMask(formatDPI)

  const load = useSelector((state: RootState) => state.user.resetPassword.load)
  const error = useSelector((state: RootState) => state.user.resetPassword.error)
  const tokenGenerated = useSelector((state: RootState) => state.user.resetPassword.tokenGenerated)

  const handleContinue = () => {
    const cleanTaxId = taxId.replaceAll('-', '')
    
    // Salva o taxId no estado para usar nas próximas telas
    dispatch(resetPasswordUpdateState({ taxId: cleanTaxId }))
    
    // Chama API para gerar token
    dispatch(generateTokenRequest({ TaxId: cleanTaxId }))
  }

  // Listen for successful token generation
  useEffect(() => {
    if (tokenGenerated) {
      navigate(paths.user.resetPassword.validateToken)
    }
  }, [tokenGenerated, navigate])

  // Show error messages
  useEffect(() => {
    if (error) {
      showToast(error, 'error')
    }
  }, [error])

  return (
    <PageContainer
      type="unauthenticated"
      footerClass='flex w-full flex-col items-center justify-between gap-12 px-8'
      footer={
        <div className="flex w-full flex-col items-center py-12">
          {load && <Loader />}
          <Button
            className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
            onClick={handleContinue}
            disabled={taxId.replaceAll('-', '').length !== 13 || load}
          >
            {load ? 'Enviando...' : 'Continuar'}
          </Button>
          <Button
            variant="outlined"
            className="h-[55px] w-full rounded-[10px] text-xl font-semibold mt-4"
            onClick={() => {
              dispatch(resetPasswordResetState())
              navigate(paths.authentication.login)
            }}
            disabled={load}
          >
            Regresar
          </Button>
        </div>
      }
    >
      <div className="flex w-full flex-col items-center justify-between gap-12 px-8">
        <div className="flex w-full flex-col gap-2 pt-8">
          <p className="pb-6 text-lg font-normal">Recuperar PIN</p>
          <div className="flex flex-col gap-8">
            <Input
              onChange={e => setTaxId(e.target.value)}
              value={taxId}
              placeholder="DPI"
              maxLength={15}
              inputMode="numeric"
            />
          </div>
        </div>
      </div>
    </PageContainer>
  )
}
